import ItemMenuSquares from 'global/wrappers/ItemMenuSquares '
import _ from 'lodash'
import { useContext, useState } from 'react'
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext'
import FullPageWrapper from '../../../../global/wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper'
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext'

const TeamList = (props) => {

  const { contentOnly } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { fns } = parentContext ?? {}
  const { navigation_fns } = fns

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { teams_info } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}

  const handleCancel = () => {
    sportsSeason_handlers.handleShow_sportsElem()
    if (props.handleCancel) {
      props.handleCancel()
    }
  }

  const handleClick = (team) => {
    sportsSeason_handlers.handleShow_sportsElem()
    if (props.handleSelect) {
      props.handleSelect(team)
    } else {
      team && navigation_fns && sportsSeason_handlers.handleGoTo_team(navigation_fns, team)
    }
  }
  const ims = (sz, caption) => <ItemMenuSquares menuItems={sz} onClick={handleClick} caption={caption} icon={'list'} iconItem={'users'} />

  const ims_teams = () => {
    const grouped = _.mapValues(
      _.groupBy(teams, (t) => _.toUpper(_.first(t.name))),
      (group) => _.sortBy(group, 'name')
    );
    const imsz = _.map(
      _.sortBy(_.keys(grouped)),
      (gk) => ims(grouped[gk], gk)
    );
    return <Wrapper
      content={imsz}
      wrapperType={wrapperTypes.padded}
    >
    </Wrapper>
  }

  const wrapper = () => <Wrapper
    content={ims_teams()}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
  />

  const fpw_teamList = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCancel}
    topperCaption={'Team Lookup'}
  ></FullPageWrapper>

  return contentOnly ? wrapper() : fpw_teamList()
}

export default TeamList